import React from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import { Breadcrumb } from "app/navigation/breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";
import { getUser } from "@microdoing/shared/services/user/selectors";
import FastImage from "react-native-fast-image";
import normalize from "app/utils/normalize";
import { useNavigation } from "@react-navigation/native";
import { IBreadCrumbPath } from "app/navigation/breadcrumb/types";

interface IProps extends IBreadCrumbPath {}

export const WebHeader = ({ breadcrumbsPath = [] }: IProps) => {
  const navigation = useNavigation();
  const user = useSelector(getUser);

  const handlePressUser = () => {
    navigation.navigate("UserProfile");
  };

  return (
    <Box
      marginBottom="xl"
      width="100%"
      flexDirection="row"
      justifyContent="space-between"
      height={40}
    >
      <Breadcrumb breadcrumbsPath={breadcrumbsPath} />
      <PressableOpacity
        onPress={handlePressUser}
        style={{ alignItems: "center", flexDirection: "row" }}
      >
        <MainText
          marginRight="sm"
          variant="l4-medium"
        >{`${user.firstName}.${user.lastName[0]}`}</MainText>
        {user.picture && (
          <FastImage
            source={{ uri: user.picture }}
            style={{
              width: normalize(24),
              height: normalize(24),
              borderRadius: normalize(12),
            }}
          />
        )}
      </PressableOpacity>
    </Box>
  );
};
